import { ApiService } from '../../app-lite/api/api.service';

import CommunicationCenterHtml from './communication-center.html';

export function CommunicationCenterStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider.state({
    controller : 'CommunicationCenterCtrl',
    name       : 'app.communication-center',
    templateUrl: CommunicationCenterHtml,
    url        : '/communication-center',
    resolve    : {
      communicationTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/communication_types'),
      contactTypes      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/communication_contact_types'),
      customerSources   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customer_sources', null, 'customerSources')
    }
  });
}